import {
    fetchGetCreditCardOnboardingRequirements,
    GetCreditCardOnboardingRequirementsResponse
} from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import { useStateKey } from '../../../../iwQueryClient/useStateKey';

export type TCreditCardOnboardingRequirements =
    GetCreditCardOnboardingRequirementsResponse['data']['onboarding_requirements'];

export const useGetOnboardingRequirements = () => {
    const stateKey = useStateKey();
    const { data: onboardingRequirements } = useQuery({
        queryKey: ['credit-card-onboarding-requirements', stateKey],
        queryFn: async () => {
            const responseData = await fetchGetCreditCardOnboardingRequirements(
                {
                    stateKey
                }
            );
            return responseData as GetCreditCardOnboardingRequirementsResponse;
        },
        suspense: true,
        select: (response: GetCreditCardOnboardingRequirementsResponse) =>
            response.data.onboarding_requirements
    });
    return {
        onboardingRequirements:
            onboardingRequirements as TCreditCardOnboardingRequirements
    };
};
